import { Icon, SvgIconType } from '@aqarmap/aqarmap-ui';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { PropertiesType } from '~/modules/addListing/types';
import { useGetAllPropertyTypeQuery } from '~/redux/api/userApiSlice';

type PropertyType = {
  id: number;
  label: string;
  icon: SvgIconType;
};

const PropertyType = () => {
  const { t } = useTranslation('app');
  const [properties, setProperties] = useState<PropertiesType[]>([]);
  const { data, isSuccess, isLoading } =
    useGetAllPropertyTypeQuery('isEvaluable=true');

  const selectedPropertyClassName =
    'border-blue_light_2 bg-blue_light_2 text-blue';
  const unSelectedPropertyClassName = 'border-gray bg-white text-gray__dark_1';

  const {
    watch,
    setValue,
    formState: { errors },
    clearErrors,
  } = useFormContext<{ propertyType: number }>();
  const isError = errors.propertyType;

  const propertyTypeValue = watch('propertyType');

  useEffect(() => {
    if (isSuccess) setProperties(data.data);
  }, [isSuccess]);

  return (
    <div className="flex flex-col gap-2x">
      <p className="text-title_4 text-black">{t('propertyType')}</p>
      <div className="flex flex-col gap-3">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5x">
          {isLoading ? (
            <>
              <Skeleton className="w-[100%] h-[72px]" />
              <Skeleton className="w-[100%] h-[72px]" />
              <Skeleton className="w-[100%] h-[72px]" />
              <Skeleton className="w-[100%] h-[72px]" />{' '}
            </>
          ) : (
            properties &&
            properties.map((property) => (
              <button
                className={`${isError ? 'border-red_dark' : ''} ${propertyTypeValue === property.id ? selectedPropertyClassName : unSelectedPropertyClassName} h-[72px] flex flex-col items-center justify-center py-1.5x border rounded-lg text-center text-body_3 text-body_2`}
                onClick={() => {
                  setValue('propertyType', property.id);
                  clearErrors('propertyType');
                }}
              >
                <Icon name="listing" size="24px" className="w-6 h-6" />
                <span className="w-max">{property.singularName}</span>
              </button>
            ))
          )}
        </div>
        {isError && (
          <p className="text-red_dark">{t('requiredPropertyType')}</p>
        )}
      </div>
    </div>
  );
};

export default PropertyType;
